import { CheckOutlined  } from '@ant-design/icons';
import { Row, Col, Table, Button } from "antd";
import Column from "antd/es/table/Column";
import { ThongBaoChungResponse } from "@app/models/thongbaochung/ThongBaoChung";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { capNhatTrangThaiDocThongBao, timKiemThongBaoChungTrangChu } from "@app/services/thongbaochung";
import { toast } from "react-toastify";
import { loaiCapNhatTB, loaiThongBao } from '../../constants';
import { Links } from '@app/helpers/Links';
import { Link } from 'react-router-dom';

const ThongBaoChungTable = () => {    
    const [dataThongBao, setDataThongBao] = useState<Array<ThongBaoChungResponse>>([]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const user = useSelector((state: any) => state.auth.currentUser);

    const capNhatThongBao = async (id: number, reload: boolean, loai: number) => {
        await capNhatTrangThaiDocThongBao(id, loai);
        setReloadPage(reload);
    };
    
    const loadThongBaoChung = async (idNhanVien: number, start: number, length: number, page: number) => {
        setIsLoadingTable(true);
        try {
            const temp = await timKiemThongBaoChungTrangChu(idNhanVien, start, length);
            var dataTB: Array<ThongBaoChungResponse> = temp?.data
            while (dataTB.length < 5) {
                dataTB.push(new ThongBaoChungResponse());
            }
            setDataThongBao(dataTB);
        } catch (ex: any) {
            toast.error(ex);
        }
        setIsLoadingTable(false);
    };
    useEffect(() => {
        if (reloadPage) {
            loadThongBaoChung(user.idNhanVien, 0, 100, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (
        <>
        <Row style={{ marginBottom: "10px" }}>
            <Col span="24">
                <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Thông báo</b></Row>
            </Col>
        </Row>
        <Row>
            <div className="card" style={{ width: "100%" }}>
                <Table
                    scroll={{ y: 195, x: "max-content" }}
                    pagination={false}
                    size="small"
                    loading={isLoadingTable}
                    locale={{ emptyText: "Không có dữ liệu" }}
                    dataSource={dataThongBao.map((item: any, index: any) => {
                        return { ...item, key: index }
                    })}
                >
                    <Column title="Loại thông báo" width={"145px"} dataIndex="tenLoaiThongBao" key="tenLoaiThongBao" />
                    <Column title="" key="action"
                        render={(value, record: any, index) =>
                        (record.id != null ?
                            <Button
                                title="Xác nhận đã xử lý"
                                size={"small"}
                                loading={isLoadingTable}
                                type="primary"
                                icon={<CheckOutlined rev="" />}
                                onClick={() => {
                                    capNhatThongBao(record.id, true, loaiCapNhatTB.daXuLy);
                                }}
                            >
                            </Button> : <div style={{ height: "22px" }}></div>
                        )
                        }
                    />
                    <Column
                        align="left"
                        title="Nội dung"
                        key="noiDung"
                            render={(value, record: any, index) => {
                                if (record.idChiTiet == 0) {
                                    switch (record.loaiThongBao) {
                                        case loaiThongBao.tongHopChamCong:
                                            return <Link
                                                to={Links.ChamCong.ThongKeChamCong + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.tongHopKPI:
                                            return <Link
                                                to={Links.KPI.KPIPhongBan + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.kpi:
                                            return <Link
                                                to={record.params ? Links.KPI.DuyetKPI + "?" + record.params : undefined}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.yKienKPI:
                                            return <Link
                                                to={Links.KPI.YKienKPI + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.tongHopDKDT:
                                            return <Link
                                                to={Links.DangKyDaoTao.Xem + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.dangKyDaoTao:
                                            return <Link
                                                to={record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;

                                        case loaiThongBao.kiemKeTaiSan:
                                            return <Link
                                                to={Links.TaiSan.ChiTietDotKiemKe + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        default:
                                            if (record.params)
                                            return <Link
                                                to={record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                            return <span>{record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}</span>
                                    }
                                } else {
                                    switch (record.loaiThongBao) {
                                        case undefined:
                                            return index == 0 && <div style={{ paddingLeft: "35px" }}>Không có dữ liệu</div>;
                                        case loaiThongBao.donThemGio:
                                            return <Link
                                                to={Links.NgoaiGio.Xem + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.donNghiPhep:
                                            return <Link
                                                to={Links.Phep.Xem + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.chamCongThang:
                                            return <Link
                                                to={Links.ChamCong.ChiTietChamCongThang + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.chamNgoaiGio:
                                            return <Link
                                                to={Links.ChamCong.ChiTietChamNgoaiGio + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.kpi:
                                            return <Link
                                                to={Links.KPI.ChiTietKPI + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.yKienKPI:
                                            return <Link
                                                to={Links.KPI.ChiTietKPI + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.congViec:
                                            return <Link
                                                to={Links.CongViec.Xem + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.giaoViec:
                                            return <Link
                                                to={Links.CongViec.Xem + "?id=" + record.idChiTiet}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                                onClick={() => { capNhatThongBao(record.id, false, loaiCapNhatTB.daXem) }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.hopDong:
                                            return <Link
                                                to={record.params == null ? Links.HopDong.CaNhan : Links.HopDong.Xem + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.quyetDinhBacLuong:
                                            return <Link
                                                to={record.params == null ? Links.HopDong.CaNhan : Links.HopDong.Xem + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.dangKyDaoTao:
                                            return <Link
                                                to={record.params == null ? Links.DangKyDaoTao.ChiTietCaNhan + "?id=" + record.idChiTiet : Links.DangKyDaoTao.ChiTietCaNhan + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        case loaiThongBao.banGiaoTaiSan:
                                            return <Link
                                                to={record.params == null ? Links.BienBanBanGiao.Xem + "?id=" + record.idChiTiet : Links.BienBanBanGiao.Xem + "?" + record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                        default: 
                                            return <Link
                                                to={record.params}
                                                title={record.noiDung}
                                                style={{ fontWeight: record.trangThai == 0 ? "bold" : "normal" }}
                                            >
                                                {record.noiDung.length > 100 ? record.noiDung.substring(0, 100) + "..." : record.noiDung}
                                            </Link>;
                                    }
                                }
                        }}
                    />
                </Table>
            </div>
        </Row>
        </>
    );
};

export default ThongBaoChungTable;
